// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"984b01df","453":"f868ffde"}[chunkId] + ".chunk.js";
};